module.exports = __webpack_public_path__ + "static/media/jeremy-bishop-1634576-unsplash.71b3ff61.jpg";